export function makeApiRequest(requestFn, selector = response => response?.data) {
  return async function (...args) {
    try {
      const response = await requestFn(...args)
      return selector(response)
    } catch (e) {
      console.error('[makeApiRequest] error:', {
        error: e,
        message: e?.message,
        response: e?.response,
        status: e?.response?.status,
        data: e?.response?.data,
        code: e?.code,
        stack: e?.stack,
      })
      throw e
    }
  }
}
